import { WORKSPACE_NAME_REGEX } from '../../../../constants/workspaces';
import Input from '../../../../components/atoms/input';
import UploadAvatarCard from '../../../../components/organisms/upload-avatar-card';
import useDebounce from '../../../../utils/debounce';
import useWorkspaceCreation from '../../../../context/WorkspaceCreationContext';

// regex to validate the workspace name
const regex = new RegExp(WORKSPACE_NAME_REGEX);

const BasicWorkspaceDetails = () => {
  // init
  const { workspaceName, workspaceId, setWorkspaceHandle, workspaceLogo, setWorkspaceName, setWorkspaceLogo, errors, removeError } = useWorkspaceCreation();
  const [debouncedWorkspaceName] = useDebounce(workspaceName, 500);

  const handleWorkspaceNameChange = (event) => {
    if (regex.test(event.target.value)) removeError('workspaceName');
    setWorkspaceName(event.target.value);
    if (!workspaceId) setWorkspaceHandle(event.target.value.toLowerCase().replace(/\s/g, ''));
  };

  const handleAvatarRemove = () => {
    setWorkspaceLogo({ blob: undefined, dataURI: undefined, file: undefined });
  };

  return (
    <div className="workspace-creation-step-body">
      <h2 className="step-title">What should we call your new workspace?</h2>
      {/* Workspace name */}
      <div className="border-cards">
        <div className="border-card">
          <span className="border-card-title">What is the name of your workspace or company?</span>
          <div className="border-card-input-container">
            <span className="border-card-label">Enter Workspace name</span>
            <Input error={!!errors.workspaceName} helperText={errors.workspaceName} autoFocus placeHolder="Enter Workspace name" onChange={handleWorkspaceNameChange} value={workspaceName} />
          </div>
        </div>
        {/* Workspace Logo */}
        <UploadAvatarCard name={debouncedWorkspaceName || 'W'} title="Upload your workspace logo." uploadButtonText="Upload Logo" isOptional avatar={workspaceLogo.dataURI} onUpload={setWorkspaceLogo} onRemove={handleAvatarRemove} />
      </div>
    </div>
  );
};

export default BasicWorkspaceDetails;
